module.exports = __webpack_public_path__ + "static/media/SL 2.55a03598.mp3";